import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CheckoutData from './../../_common/_props/PrimerCheckoutDataPropsIos.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func primerDidFailWithError(_ error: Error, data: PrimerCheckoutData?, decisionHandler: @escaping ((PrimerErrorDecision) -> Void))
`}</code></pre>
    <p>{`This method will be called when an error occurs. It may return `}<inlineCode parentName="p">{`PrimerCheckoutData`}</inlineCode>{` if the occurs after the payment creation.
Make sure you call the `}<inlineCode parentName="p">{`decisionHandler`}</inlineCode>{` to finalize the flow.`}</p>
    <h3>{`Parameters`}</h3>
    <Group mdxType="Group">
	<Item title='error' subtitle='Error' label='Required' mdxType="Item"></Item>
	<Item title='data' subtitle='PrimerCheckoutData' label='Optional' mdxType="Item">
		<Group summary='parameters' open mdxType="Group">
			<CheckoutData mdxType="CheckoutData" />
		</Group>
	</Item>
	<Item title='decisionHandler' subtitle='PrimerErrorDecision' label='Required' mdxType="Item">
		<Group summary='enum cases' open mdxType="Group">
			<Item title='fail(withErrorMessage:)' mdxType="Item">{'Call with your custom error message.'}</Item>
		</Group>
	</Item>
    </Group>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`// 👇 Add this
import PrimerSDK

// 👇 Conform to PrimerDelegate
class MyViewController: UIViewController, PrimerDelegate {

    // ...

    // 👇 Add this
    func primerDidFailWithError(_ error: Error, data: PrimerCheckoutData?, decisionHandler: @escaping ((PrimerErrorDecision) -> Void)) {

    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      